import { tranStr } from "../../utils/translation";

export const CORRESPONDENCE = {
  TITLE: tranStr("Correspondence"),
  SHOW_CLOSED_OUT_COMMENTS_TOGGLE_SWITCH_LABEL: tranStr(
    "Show Closed-Out Comments"
  ),
  PROJECTS_LIST_SECTION_PENDING_LABEL: tranStr("Pending"),
  PROJECTS_LIST_SECTION_CLOSED_OUT_LABEL: tranStr("Closed-Out"),
  REQUIRE_PROJECT_SELECTION_HINT: tranStr(
    "Select a project from the left pane to view correspondence."
  ),
  NO_COMMENTS_FOUND: tranStr("No breakdown comments found for estimate."),
  ALL_COMMENTS_CLOSED_OUT: tranStr(
    "All breakdown comments for this estimate are closed-out."
  ),
};
